import { makeStyles } from '@material-ui/core'

import type { Theme } from '@material-ui/core'

export const useStepNavigationFooterStyles = makeStyles<Theme>(() => ({
  root: {
    position: 'sticky',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 'var(--vel-fixed-spacing-04)',
    padding: 'var(--vel-fixed-spacing-04) var(--vel-fixed-spacing-05)',
    backgroundColor: 'var(--vel-color-neutral-white)',
    borderTop: '1px solid var(--vel-color-neutral-300)',
  },
  // Keeps the Next button pinned right even when Previous is hidden
  spacer: {
    marginLeft: 'auto',
  },
}))
